// extracted by mini-css-extract-plugin
module.exports = {"refStaffMemberDepartmentTagsItemWrapper":"refStaffMemberDepartmentTagsItemWrapper--2QaMzErD","checkbox":"checkbox--1zn2-_FO"};